module.exports = __webpack_public_path__ + "static/blob-top-galini-635e6b3ea5c04aef03be1e1a14c06afc.png";